import StyledComponents from './StyledComponents';


export default StyledComponents;



// WEBPACK FOOTER //
// ./src/components/StyledComponents/index.js